module.exports = __webpack_public_path__ + "media/images/front/home_2-e1f2773c1fb98d1df5acb759cedce34c.webp";